import groq from 'groq';

/**
 * When loading this Block in a modular content block, the following fields will be loaded.
 * Ensure all fields used in your block are loaded below.
 * _type and _key will always be included, and do not need to be specified below.
 *
 * The fields are loaded with the "..." selector, to get all fields for the block.
 * However, if you need to follow references, rename fields, or do anything else other than
 * get fields, then add these extra bits to the groq export below.
 *
 * If you use inner blocks, these must be in a `content` field.
 *
 * It will then be included like so:
 *   ...,
 *   _type == "YOUR_BLOCK" => {
 *     YOUR_FIELDS,
 *   }
 */
export const blockSolutionFinderFields = groq`
  vendorTypes[]->{
    _id,
    _type,
    title,
    icon,
  }
`;
